import type { FireflyTranslateLocaleCodeInput } from '@frameio/graphql-client/generated/types';
import TEXT from './generated/TEXT/dubLanguages';

TEXT.DEFINE({
  /** Chinese (Simplified, China) */
  chineseSimplifiedChina: 'Chinese (Simplified, China)',
  /** Danish */
  danish: 'Danish',
  /** Dutch */
  dutch: 'Dutch',
  /** English as spoken in India */
  englishIndia: 'English (India)',
  /** English as spoken in the United Kingdom */
  englishUk: 'English (UK)',
  /** English as spoken in the United States */
  englishUs: 'English (US)',
  /** French as spoken in Canada */
  frenchCanada: 'French (Canada)',
  /** French as spoken in France */
  frenchFrance: 'French (France)',
  /** German */
  german: 'German',
  /** Hindi */
  hindi: 'Hindi',
  /** Italian */
  italian: 'Italian',
  /** Japanese */
  japanese: 'Japanese',
  /** Korean */
  korean: 'Korean',
  /** Norwegian */
  norwegian: 'Norwegian',
  /** Portuguese as spoken in Brazil */
  portugueseBrazil: 'Portuguese (Brazil)',
  /** Portuguese as spoken in Portugal */
  portuguesePortugal: 'Portuguese (Portugal)',
  /** Spanish as spoken in Argentina */
  spanishArgentina: 'Spanish (Argentina)',
  /** Spanish as spoken in Latin America */
  spanishLatinAmerica: 'Spanish (Latin America)',
  /** Spanish as spoken in Spain */
  spanishSpain: 'Spanish (Spain)',
  /** Swedish */
  swedish: 'Swedish',
});

export type TranslateVideoLanguageOption = {
  code: FireflyTranslateLocaleCodeInput;
  label: string;
};

export function getTranslateVideoLanguageOptions(): TranslateVideoLanguageOption[] {
  return [
    { label: TEXT.chineseSimplifiedChina, code: 'ZH_CN' },
    { label: TEXT.danish, code: 'DA_DK' },
    { label: TEXT.dutch, code: 'NL_NL' },
    { label: TEXT.englishIndia, code: 'EN_IN' },
    { label: TEXT.englishUk, code: 'EN_GB' },
    { label: TEXT.englishUs, code: 'EN_US' },
    { label: TEXT.frenchCanada, code: 'FR_CA' },
    { label: TEXT.frenchFrance, code: 'FR_FR' },
    { label: TEXT.german, code: 'DE_DE' },
    { label: TEXT.hindi, code: 'HI_IN' },
    { label: TEXT.italian, code: 'IT_IT' },
    { label: TEXT.japanese, code: 'JA_JP' },
    { label: TEXT.korean, code: 'KO_KR' },
    { label: TEXT.norwegian, code: 'NB_NO' },
    { label: TEXT.portugueseBrazil, code: 'PT_BR' },
    { label: TEXT.portuguesePortugal, code: 'PT_PT' },
    { label: TEXT.spanishArgentina, code: 'ES_AR' },
    { label: TEXT.spanishLatinAmerica, code: 'ES_419' },
    { label: TEXT.spanishSpain, code: 'ES_ES' },
    { label: TEXT.swedish, code: 'SV_SE' },
  ];
}
